import api from './api'
import { parseParams } from './common'

export default {
  getMobileAudience (widget, selection) {
    const widgetOptions = ['unique_users', 'demography', 'total_reached_population', 'zone_affinity_index', 'interests']
    if (widgetOptions.indexOf(widget) === -1) {
      throw new Error('[exploreService] invalid widget option: ', widget)
    }
    return api.post(`/explore/stats/mobileaudience?stat=${widget}`, selection)
      .then(res => res.data)
  },
  getEconomy (widget, selection) {
    const widgetOptions = ['pois']
    if (widgetOptions.indexOf(widget) === -1) {
      throw new Error('[exploreService] invalid widget option: ', widget)
    }
    return api.post(`/explore/stats/economy?stat=${widget}`, selection)
      .then(res => res.data)
  },
  getCensus (widget, selection) {
    const widgetOptions = ['education_level', 'house_holds', 'marital_status', 'census_demography']
    if (widgetOptions.indexOf(widget) === -1) {
      throw new Error('[exploreService] invalid widget option: ', widget)
    }
    return api.post(`/explore/stats/census?stat=${widget}`, selection)
      .then(res => res.data)
  },
  createArea ({ lng, lat, radius }) {
    return api.post('/customareas', {
      name: 'Area personalizada',
      radius,
      the_geom: {
        type: 'Point',
        coordinates: [lng, lat]
      }
    }).then(res => res.data)
  },
  getGeoTemplates (params = {}) {
    const urlParams = parseParams(params)
    return api.get(`/geo/templates?${urlParams}`).then(res => res.data)
  },
  saveGeoTemplate ({ id, name, geometries, type, shops }) {
    let body = {
      name,
      type,
      regions: geometries.map(g => g.id)
    }
    if (shops) {
      body.shops = shops
    }
    const method = id ? 'put' : 'post'
    const url = id ? `/geo/templates/${id}` : '/geo/templates'
    return api[method](url, body).then(res => res.data)
  },
  deleteZipcodeGroup (id) {
    return api.delete(`/geo/templates/${id}`).then(res => res.data)
  }
}
